import 'jquery';

export default {
  init() {

    (function($) {

      let btnSwitchMap = document.querySelector('.btn__show-map');
      btnSwitchMap.addEventListener('click', function (e){
        e.preventDefault()


        const mapArea = document.querySelector('.map-area');
        const cardView = document.querySelector('.card-view');
        const mapTitle = document.querySelector('.map_title');
        const mapIcon = document.querySelector('.map_icon');

        // $( ".map-area" ).toggle('slow');
        $(".map-area, .card-view").slideToggle();

        if(mapTitle.innerHTML == 'View Map') {
          mapTitle.innerHTML = 'Grid View'
        }else {
          mapTitle.innerHTML = 'View Map'
        }

        if(mapIcon.innerHTML == '<i class="fa-solid fa-location-dot"></i>'){
          mapIcon.innerHTML = '<i class="fas fa-border-all"></i>'
        }else {
          mapIcon.innerHTML = '<i class="fa-solid fa-location-dot"></i>'
        }

      })

      let btnSwitchMap1 = document.querySelector('.btn__show-map1');
      btnSwitchMap1.addEventListener('click', function (e){
        e.preventDefault()


        const mapArea = document.querySelector('.map-area');
        const cardView = document.querySelector('.card-view');
        const mapTitle = document.querySelector('.btn_show-map_label');
        const mapIcon = document.querySelector('.btn_show-map_icon');



        // $( ".map-area" ).toggle('slow');
        $(".map-area, .card-view").slideToggle();

        if(mapTitle.innerHTML == 'View Map') {
          mapTitle.innerHTML = 'Grid View'
        }else {
          mapTitle.innerHTML = 'View Map'
        }

        if(mapIcon.innerHTML == '<i class="fa-solid fa-location-dot"></i>'){
          mapIcon.innerHTML = '<i class="fas fa-border-all"></i>'
        }else {
          mapIcon.innerHTML = '<i class="fa-solid fa-location-dot"></i>'
        }



      })

    })(jQuery);

  },
};
